export const isProduction = ['production.domain.com'].includes(
  window?.location.hostname,
)
export const isBeta = ['beta.domain.com'].includes(
  window?.location.hostname,
)
